const isSameOriginUrl = (url: string) => {
  try {
    return (
      new URL(url, window.location.origin).origin === window.location.origin
    );
  } catch {
    return false;
  }
};

export default isSameOriginUrl;
